import Set from "./component-library378.mjs";
import noop from "./component-library379.mjs";
import setToArray from "./component-library327.mjs";
var INFINITY = 1 / 0;
var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function(values) {
  return new Set(values);
};
const createSet$1 = createSet;
export {
  createSet$1 as default
};
